import * as types from "../actions/ActionTypes";
import { dogDetails } from "../store/InitialStore";

export default function Dogdetails(state = dogDetails, action) {
  const { type, payload } = action;
  switch (type) {
    case types.ALL_DOG:
      return [...state, ...payload];

    default:
      return state;
  }
}
